<vi-page [sidenavs]="true" [footer]="true" [isWhiteBackground]="true">
  <app-downtime-notification head></app-downtime-notification>
  <app-callback-notification head></app-callback-notification>
  <vi-toolbar head color="white">
    <vi-back-button left gtm="onBreadcrumbBack" gtmCategory="booking"></vi-back-button>
    <vi-breadcrumbs
      left
      gtm="onBreadcrumb"
      gtmCategory="booking"
      formerPage="{{ 'GENERAL.PATH.OVERVIEW' | translate }}"
      currentPage="{{ 'GENERAL.PATH.BOOKING_OVERVIEW' | translate }}"
      [navigateTo]="'/installations'"
    ></vi-breadcrumbs>
  </vi-toolbar>

  <vi-content body layoutAlign="justify-start items-start">
    <ng-container
      main
      *ngIf="(installationsStore.loaded$ | async) && (bookingStore.loaded$ | async); else loader"
    >
      <!-- Booked package -->
      <ng-container
        *ngIf="
          bookingStore.activeOrCanceledFlatRateSubscription$ | async as subscription;
          else noPackageBooked
        "
      >
        <div class="packages-header">
          <h1 data-at-title>
            {{ '+INSTALLATIONS.INSTALLATION.BOOKED_PACKAGE_CARD.TITLE' | translate }}
          </h1>
        </div>
        <div class="subscriptions-container">
          <!-- Show trial tile -->
          <app-booking-subscription-details
            *ngIf="
              bookingStore.getActiveTrialSubscriptionForFlatRate$ | async as trialSubscription;
              else showProSubscription
            "
            [subscription]="trialSubscription"
          ></app-booking-subscription-details>

          <!-- Show flat rate pro tile if it's not trial-->
          <ng-template #showProSubscription>
            <app-flat-rate-status-tiles
              [isActiveSubscription]="true"
              [subscription]="subscription"
            ></app-flat-rate-status-tiles>
          </ng-template>
        </div>
      </ng-container>

      <!-- No booked package notification -->
      <ng-template #noPackageBooked>
        <div class="packages-header">
          <h1 data-at-title>
            {{ '+INSTALLATIONS.INSTALLATION.BOOKED_PACKAGE_CARD.TITLE' | translate }}
          </h1>
          <vi-text class="no-package-info">
            {{ '+BOOKING.OVERVIEW.FLATRATE.NO_PACKAGE_BOOKED' | translate }}
          </vi-text>
        </div>
      </ng-template>

      <!-- Expired packages -->
      <ng-container
        *ngIf="bookingStore.expiredFlatRateSubscriptions$ | async as expiredSubscriptions"
      >
        <div class="packages-header">
          <h2 data-at-title>
            {{ '+BOOKING.OVERVIEW.FLATRATE.EXPIRED_SUBSCRIPTIONS' | translate }}
          </h2>
        </div>
        <div class="subscriptions-container">
          <ng-container *ngFor="let expiredSubscription of expiredSubscriptions">
            <!-- Expired pro flat rate packages -->
            <app-flat-rate-status-tiles
              *ngIf="!expiredSubscription.trial"
              [subscription]="expiredSubscription"
              [isAnyActiveOrCancelledSubscription]="
                !!(bookingStore.activeOrCanceledFlatRateSubscription$ | async)
              "
            ></app-flat-rate-status-tiles>

            <!-- Expired trial package -->
            <app-booking-subscription-details
              *ngIf="expiredSubscription.trial"
              [subscription]="expiredSubscription"
              [isAnyActiveOrCancelledFlatRateSubscription]="
                !!(bookingStore.activeOrCanceledFlatRateSubscription$ | async)
              "
            ></app-booking-subscription-details>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #loader>
      <vi-loader main [isLoading]="true"></vi-loader>
    </ng-template>
  </vi-content>

  <vi-dsw-footer footer data-at-footer></vi-dsw-footer>
  <app-sidenav left-sidenav></app-sidenav>
</vi-page>
